import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight, FiMaximize2, FiMapPin } from 'react-icons/fi';

export default function GiantMinimal({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Essência Oculta';
    const price = data?.preco || data?.price;
    const location = data?.bairro || data?.location || 'Localização sob consulta';
    const city = data?.cidade || '';
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1449156001437-37c645d9bc8c';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : price || 'Consulte';

    return (
        <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="w-full h-[750px] bg-white p-16 flex flex-col justify-between border border-gray-100 rounded-[5.5rem] shadow-sm relative group overflow-hidden"
            style={{ backgroundColor: 'var(--bg-card)' }}
        >
            {/* 🌑 GRID DE CONTRASTE MÍNIMO (Background Decorativo) */}
            <div className="absolute top-0 right-0 p-16 opacity-[0.03] pointer-events-none">
                <FiMaximize2 size={400} />
            </div>

            {/* 🏛️ HEADER: TIPOGRAFIA EDITORIAL */}
            <div className="flex justify-between items-start relative z-10">
                <div className="space-y-4">
                    <span className="text-[9px] font-black uppercase tracking-[0.6em] text-gray-400">Design Minimalista // V11</span>
                    <h2 className="text-6xl font-light tracking-tighter text-gray-900 leading-[0.9] uppercase italic"
                        style={{ color: 'var(--text-primary)' }}>
                        {title}
                    </h2>
                    <p className="flex items-center gap-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                        <FiMapPin style={{ color: color || 'var(--accent-color)' }} /> {location} {city && `// ${city}`}
                    </p>
                </div>
                
                <div className="flex flex-col items-end">
                    <span className="text-[10px] font-black text-gray-300 mb-2">REF: 01/15</span>
                    <div className="w-12 h-px bg-gray-200" />
                </div>
            </div>

            {/* 🖼️ CANVAS: MOLDURA CINEMATOGRÁFICA */}
            <div className="relative h-[450px] w-full rounded-[3.5rem] overflow-hidden shadow-2xl mt-12 group">
                <img 
                    src={mainImage} 
                    className="w-full h-full object-cover transition-transform duration-[2s] group-hover:scale-105" 
                    alt={title}
                />
                
                {/* Overlay de Preço Flutuante (Estilo Galeria) */}
                <div className="absolute bottom-10 right-10 bg-white/90 backdrop-blur-xl px-10 py-6 rounded-3xl shadow-2xl border border-white/20">
                    <span className="block text-[8px] font-black uppercase tracking-widest text-gray-400 mb-1">Valor do Ativo</span>
                    <div className="text-3xl font-black text-gray-900 tracking-tighter">
                        {formattedPrice}
                    </div>
                </div>

                {/* Botão de Ação Stealth */}
                <button 
                    className="absolute top-10 right-10 w-16 h-16 bg-black rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-all duration-500 hover:scale-110 active:scale-90 shadow-2xl"
                    style={{ backgroundColor: color || 'var(--accent-color)' }}
                >
                    <FiArrowUpRight size={24} />
                </button>
            </div>

            {/* 🖋️ FOOTER: ASSINATURA DE LUXO */}
            <div className="flex justify-between items-center mt-10">
                <div className="flex gap-12">
                    <div className="flex flex-col">
                        <span className="text-[8px] font-black uppercase tracking-widest text-gray-400">Status</span>
                        <span className="text-[10px] font-bold text-gray-900 uppercase tracking-tighter" style={{ color: 'var(--text-primary)' }}>Pronto para Morar</span>
                    </div>
                    <div className="flex flex-col">
                        <span className="text-[8px] font-black uppercase tracking-widest text-gray-400">Exclusividade</span>
                        <span className="text-[10px] font-bold text-gray-900 uppercase tracking-tighter" style={{ color: 'var(--text-primary)' }}>MOS Gold Signature</span>
                    </div>
                </div>
                
                <button className="text-[10px] font-black uppercase tracking-[0.4em] text-gray-400 hover:text-black transition-colors"
                        style={{ color: 'var(--text-secondary)' }}>
                    Explorar Dossiê Completo
                </button>
            </div>
        </motion.div>
    );
}